<template>
  <div>
    <b-row>
      <b-col lg="9" cols="12" order="1" order-lg="1">
        <b-card>
          <router-view />
        </b-card>
      </b-col>

      <b-col lg="3" cols="12" order="2">
        <instructions-card />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InstructionsCard from "@/components/InstructionsCard.vue";
import { BRow, BCol, BCard } from "bootstrap-vue";
export default {
  components: { BRow, BCol, BCard, InstructionsCard },
  beforeDestroy() {
    if (this.$store.hasModule("Tashbeek"))
      this.$store.unregisterModule("Tashbeek");
  },
};
</script>
